/**
 * Copyright (C) 2017 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import LuiBase from '@here/lui-base'
import scopedCss from 'lui-status.scss'
import template from 'lui-status.html'

export default class LuiStatus extends LuiBase {
  static get is() {
    return 'lui-status'
  }

  static get cssClassToggles() {
    return ['positive', 'significant', 'negative']
  }

  static get hasLuiElementsInShadowDom() {
    return false
  }

  onConnected() {
    super.onConnected()
    this.iconChanged(null, this.getAttribute('icon'))
  }

  iconChanged(oldValue, newValue) {
    let element = this.shadowRoot.querySelector('lui-icon')
    if (newValue) {
      if (!element) {
        element = document.createElement('lui-icon')
      }
      element.setAttribute('icon', newValue)
      const span = this.shadowRoot.querySelector('span')
      span.parentNode.insertBefore(element, span)
    } else if (element) {
      this.seedElement.removeChild(element)
    }
  }

  positiveChanged() {
    this.classList.toggle('lui-positive', this.hasAttribute('positive'))
  }

  significantChanged() {
    this.classList.toggle('lui-significant', this.hasAttribute('significant'))
  }

  negativeChanged() {
    this.classList.toggle('lui-negative', this.hasAttribute('negative'))
  }

  static get css() {
    return scopedCss
  }

  static get template() {
    return template
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-status/lui-status.js
// module id = 324
// module chunks = 0 1 25